import { Text } from '@ekhodealer/ekho-common/rev';

import { DetailedInfoLineItem } from '@common/components/DetailedInfoLineItem';
import { formatCurrency } from '@common/lib/currency';

interface PricedLineItemProps {
	/** Image URL for the item. */
	imageUrl?: string;
	/** Primary display name. */
	primaryLabel: string;
	/** Optional secondary label (e.g. category, VIN). */
	secondaryLabel?: string;
	/** Optional tertiary label (e.g. description). */
	tertiaryLabel?: string;
	/** Price in cents/dollars. Shows "Free" when null, undefined, or zero. */
	price?: number | null;
}

/**
 * Standardized line item displaying an image, name, and price.
 * Shows "Free" in regular weight when price is absent or zero;
 * otherwise shows the formatted currency in semibold.
 */
export const PricedLineItem = ({
	imageUrl,
	primaryLabel,
	secondaryLabel,
	tertiaryLabel,
	price,
}: PricedLineItemProps): React.ReactNode => {
	const hasPaidPrice = price != null && price > 0;

	return (
		<DetailedInfoLineItem
			imageUrl={imageUrl}
			showPlaceholderImage
			primaryLabel={primaryLabel}
			secondaryLabel={secondaryLabel}
			tertiaryLabel={tertiaryLabel}
			rightAccessory={
				hasPaidPrice ? (
					<Text size='bodySmall' weight='semibold'>
						{formatCurrency(price)}
					</Text>
				) : (
					<Text size='bodySmall' weight='regular'>
						Free
					</Text>
				)
			}
		/>
	);
};
